import { render, staticRenderFns } from "./earth.vue?vue&type=template&id=56d921b7&scoped=true&"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d921b7",
  null
  
)

export default component.exports